
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 18 19","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.895 16.738a.4.4 0 01.105.282c0 .14-.035.246-.105.316l-.81.773a.43.43 0 01-.316.141c-.14 0-.21-.035-.28-.14l-4.29-4.255a.4.4 0 01-.105-.28v-.493a7.924 7.924 0 01-2.215 1.336 7.19 7.19 0 01-2.566.457c-1.336 0-2.567-.316-3.692-.984a6.79 6.79 0 01-2.637-2.637C.316 10.129 0 8.898 0 7.563 0 6.226.316 5.03.984 3.905c.633-1.125 1.512-2.004 2.637-2.672A7.432 7.432 0 017.313.25c1.335 0 2.53.352 3.656.984a7.484 7.484 0 012.672 2.672c.632 1.125.984 2.32.984 3.656 0 .915-.176 1.758-.492 2.567-.317.844-.738 1.582-1.301 2.215h.492a.4.4 0 01.281.105l4.29 4.29zm-10.582-3.55c.984 0 1.933-.247 2.812-.739a5.502 5.502 0 002.04-2.074 5.54 5.54 0 00.773-2.813c0-.984-.282-1.933-.774-2.812a5.668 5.668 0 00-2.039-2.04c-.879-.491-1.828-.772-2.813-.772a5.53 5.53 0 00-2.812.773A5.502 5.502 0 002.426 4.75a5.7 5.7 0 00-.739 2.813c0 1.019.247 1.968.739 2.812A5.347 5.347 0 004.5 12.449a5.513 5.513 0 002.813.739z"}})])
          )
        }
      }
    